/**
 * combines classNames in a friendly way
 *
 * @param {*} classes
 */
export const cn = (...classes) => classes.join(" ");
